import { CreateBrandModalComponent } from './../../../components/create-brand-modal/create-brand-modal.component';
import { finalize } from 'rxjs/operators';
import { BasePage } from './../../base.page';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { WardrobeService } from 'src/app/services/wardrobe.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MediaCaptureProvider } from 'src/app/services/media-capture';
import { ProductConditionModel } from './../../../models/wardrobe.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { brand, category, color, condition, size, type } from 'src/app/constants/general.constant';
import { Platform, LoadingController, ToastController, ModalController, ActionSheetController, AlertController } from '@ionic/angular';
import { ChooseLocationModalComponent } from 'src/app/components/choose-location-modal/choose-location-modal.component';
import { ProductCategoryModalComponent } from 'src/app/components/product-category-modal/product-category-modal.component';
import { ProductTypeModel, ProductBrandModel, ProductColorModel, ProductCategoryModel, ProductModel, ProductSizeModel } from 'src/app/models/wardrobe.model';
import { EditImageModalComponent } from 'src/app/components/edit-image-modal/edit-image-modal.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';

@Component({
  selector: 'shc-edit-product',
  templateUrl: './edit-product.page.html',
  styleUrls: ['./edit-product.page.scss'],
})
export class EditProductPage extends BasePage implements OnInit {
  price: number;
  form: UntypedFormGroup;
  productId: number;
  product: ProductModel;
  productImages: Array<any>;
  imagesChange: boolean;
  existingImagesLength: number;
  selectedType: ProductTypeModel;
  selectedBrand: ProductBrandModel;
  selectedColor: ProductColorModel;
  selectedCategory: ProductCategoryModel;
  selectedLocation: {
    location: string
    latitude: number
    longitude: number
  };
  deletedImages: Array<number>;
  selectedSize: ProductSizeModel;
  productConditions: Array<ProductConditionModel>;
  productTypes: Array<ProductTypeModel>;
  selectedCondition: ProductConditionModel;

  constructor(
    protected platform: Platform,
    camera: Camera,
    actionSheetCtrl: ActionSheetController,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    mediaCapture: MediaCaptureProvider,
    toastController: ToastController,
    private router: Router,
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    private wardrobeService: WardrobeService,
    protected androidPermission: AndroidPermissions,
    private alertCtrl: AlertController
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController, mediaCapture, actionSheetCtrl, camera);
  }

  ngOnInit() {
    this.existingImagesLength = 0;
    this.imagesChange = false;
    this.productImages = [];
    this.deletedImages = [];
    this.productId = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    this.form = new UntypedFormGroup({
      title: new UntypedFormControl(null, [
        Validators.required
      ]),
      description: new UntypedFormControl(null, [
        Validators.required,
        Validators.maxLength(255)
      ]),
      price: new UntypedFormControl(null, [
        // Validators.required,
        Validators.min(1)
      ]),
      size_id: new UntypedFormControl(null, [
        Validators.required
      ]),
      condition_id: new UntypedFormControl(null, [
        Validators.required
      ]),
      color_id: new UntypedFormControl(null, [
        Validators.required
      ]),
      brand_id: new UntypedFormControl(null, [
        Validators.required
      ]),
      category_id: new UntypedFormControl(null, [
        Validators.required
      ]),
      type_id: new UntypedFormControl(null, [
        Validators.required
      ]),
      location: new UntypedFormControl(null, [
        // Validators.required
      ]),
      latitude: new UntypedFormControl(null, [
        // Validators.required
      ]),
      longitude: new UntypedFormControl(null, [
        // Validators.required
      ]),
      images: new UntypedFormControl(null),
      delete_media: new UntypedFormControl(null),
      is_active: new UntypedFormControl(1)
    });
  }

  setSelectedCondition(event){
    const selectedValue = event.target.value;
    this.selectedCondition = this.productConditions?.find(pro => pro?.rating === selectedValue);
  }

  getProductConditions() {
    this.wardrobeService.conditionsList().subscribe(res => {
      this.productConditions = res.data.filter(con => con.rating !== null);
    }, error => {
      this.errorService.handle(error);
    });
  }

  getTypes() {
    this.wardrobeService.typesList({ page: 1, per_page: 100 }).subscribe(res => {
      this.productTypes = res.data;
    }, error => {
      this.errorService.handle(error);
    });
  }

  ionViewWillEnter() {
    this.productImages = [];
    this.getProductConditions();
    this.getTypes();
    this.getProductDetail();
  }

  getProductDetail() {
    this.showLoader();
    this.wardrobeService.productDetail(this.productId).pipe(
      finalize(() => this.hideLoader())
    ).subscribe((res: ProductModel) => {
      this.product = res;
      console.log(res);

      this.form.patchValue({
        title: res?.title,
        description: res?.description,
        price: res?.price,
        size: res?.size,
        condition_id: res?.condition?.rating,
        color_id: res?.color?.id,
        brand_id: res?.brand?.id,
        category_id: res?.category?.id,
        type_id: res?.type?.id,
        location: res?.location,
        latitude: res?.latitude,
        longitude: res?.longitude
      });
      this.selectedType = res.type;
      this.selectedBrand = res.brand;
      this.selectedColor = res.color;
      this.selectedCategory = res.category;
      this.selectedSize = res.size;
      this.selectedCondition = res.condition;
      this.price = res?.price ? res?.price : 1;
      this.selectedLocation = {
        location: res.location,
        latitude: res.latitude,
        longitude: res.longitude
      };
      res.images.forEach(image => {
        this.productImages.push({
          id: image?.id,
          url: image?.url
        });
        // this.imagesChange = true;
      });
    }, error => {
      this.errorService.handle(error);
    });
  }

  async openProductCategoryModal(value: string) {
    const modal = await this.modalCtrl.create({
      component: ProductCategoryModalComponent,
      componentProps: {
        value,
        typeId: this.selectedType?.id,
        categoryId: this.selectedCategory?.id,
        conditions: this.productConditions,
      },
      cssClass: 'product-category-modal-update',
      canDismiss: true,
      id: 'productCategory'
    });
    modal.onDidDismiss().then((data) => {
      if (value === brand) {
        if (data.data.name.toLowerCase() === 'others') {
          this.createBrand();
        } else {
          this.selectedBrand = data.data;
          this.form.controls.brand_id.markAsTouched();
          this.form.controls.brand_id.setErrors(null);
        }
      } else if (value === category) {
        this.selectedSize = null;

        this.selectedCategory = data.data;
        this.form.controls.category_id.markAsTouched();
        this.form.controls.category_id.setErrors(null);
      } else if (value === color) {
        this.selectedColor = data.data;
        this.form.controls.color_id.markAsTouched();
        this.form.controls.color_id.setErrors(null);
      } else if (value === size) {
        this.selectedSize = data.data;
        this.form.controls.size_id.markAsTouched();
        this.form.controls.size_id.setErrors(null);
      } else if (value === condition) {
        this.selectedCondition = data.data;
        this.form.controls.condition_id.setValue(data.data.id);
        this.form.controls.condition_id.markAsTouched();
        this.form.controls.condition_id.setErrors(null);
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async openLocationModal() {
    const modal = await this.modalCtrl.create({
      component: ChooseLocationModalComponent,
      componentProps: {
        'previousSelectedLat': this.form.value.latitude,
        'previousSelectedLng': this.form.value.longitude
      },
      cssClass: 'location-selections-update',
      canDismiss: true,
      id: 'locationModal'
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        this.selectedLocation = data.data;
        this.form.patchValue({
          location: data.data.formatted_address,
          latitude: data.data.latitude,
          longitude: data.data.longitude,
        });
        this.form.controls.location.markAsTouched();
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  async createBrand() {
    const modal = await this.modalCtrl.create({
      component: CreateBrandModalComponent,
      cssClass: 'create-brand',
      canDismiss: true,
      id: 'createBrandModal'
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        this.selectedBrand = data.data;
        this.form.controls.brand_id.markAsTouched();

      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  incrementPrice() {
    this.price++;
    this.form.controls.price.markAsTouched();

  }

  decrementPrice() {
    if (this.price > 1) {
      this.price--;
      this.form.controls.price.markAsTouched();
    } else {
      this.errorService.showToast(this.translate.instant(marker('Price.Error')));
    }
  }

  async managePicUpload(event: Event, maxImages: number) {
    event.stopPropagation();
    await this.cordovaPictureChange( maxImages);
    /*if (this.platform.is('android')) {

      this.androidPermission.checkPermission(this.androidPermission.PERMISSION.CAMERA).then(
        async (result) => {
          console.log('Has camera permission?' + JSON.stringify(result.hasPermission));
          if (!result.hasPermission) {
            await this.androidPermission.requestPermission(this.androidPermission.PERMISSION.CAMERA)
              .then(async (permResp) => {
                console.log('req camera perm response: ', permResp);
                // alert('Has camera permission?' + JSON.stringify(permResp));
                if (permResp.hasPermission) {
                  await this.cordovaPictureChange(maxImages);
                } else {
                  await this.androidPermission.requestPermission(this.androidPermission.PERMISSION.CAMERA)
                }
              });
          } else {
            await this.cordovaPictureChange(maxImages);
          }
        },
        err => this.androidPermission.requestPermission(this.androidPermission.PERMISSION.CAMERA)
      );

    } else {
      await this.cordovaPictureChange( maxImages);
    }*/
  }

  async cordovaPictureChange( maxImages: number) {
    if ((window as any).cordova && (window as any).cordova.platformId !== 'browser') {
      event.stopPropagation();
      if (this.selectedImages && this.selectedImages.length >= maxImages) {
        this.showToast(this.translate.instant(marker('ValidationMessage.MaxUploadLimit')));
        return;
      } else {
        const alert = await this.actionSheetCtrl.create({
          header: this.translate.instant(marker('Camera.Select')),
          backdropDismiss: true,
          cssClass: 'removeCancelButton',
          buttons: [
            {
              icon: 'close',
              text: this.translate.instant(marker('Buttons.Cancel')),
              role: 'cancel'
            },
            {
              icon: 'camera',
              text: this.translate.instant(marker('Camera.Source.Camera')),
              handler: () => {
                this.mediaCapture.getPicture(this.camera.PictureSourceType.CAMERA,
                  true, this.camera.MediaType.PICTURE).then(
                    async (result: any) => {
                      this.showLoader();
                      if (result) {
                        if (result.file.indexOf('data:image/') >= 0) {
                          this.editImage(result.file);
                        } else {
                          this.showToast(this.translate.instant(marker('ValidationMessage.ValidImage')));
                        }
                      }
                      this.hideLoader();
                    },
                    error => {
                      this.hideLoader();
                      if(error) {
                        this.showToast(this.translate.instant(marker('ValidationMessage.PermissionDenied')));
                      } else {
                        this.showToast(this.translate.instant(marker('ValidationMessage.NoFileSelected')));
                      }
                    }
                  );
              }
            },
            {
              icon: 'images-outline',
              text: this.translate.instant(marker('Camera.Source.PhotoLibrary')),
              handler: () => {
                this.mediaCapture.getPicture(this.camera.PictureSourceType.PHOTOLIBRARY,
                  true, this.camera.MediaType.PICTURE).then(
                    async (result: any) => {
                      this.showLoader();
                      if (result) {
                        if (result.file.indexOf('data:image/') >= 0) {
                          this.editImage(result.file);
                        } else {
                          this.showToast(this.translate.instant(marker('ValidationMessage.ImageOnly')));
                        }
                      }
                      this.hideLoader();
                    },
                    error => {
                      this.hideLoader();
                      if(error) {
                        this.showToast(this.translate.instant(marker('ValidationMessage.PermissionDenied')));
                      } else {
                        this.showToast(this.translate.instant(marker('ValidationMessage.NoFileSelected')));
                      }
                    }
                  );
              }
            }
          ]
        });
        await alert.present();
      }
    }
  }

  selectType(item: any) {
    this.selectedType = item;
    this.selectedSize = null;
    this.form.controls.type_id.setValue(item?.id);
    this.form.controls.type_id.markAsTouched();
    this.form.controls.type_id.setErrors(null);
  }

  onConditionTouch(event) {
    if (event.target.value === this.product?.condition?.id) {
      return;
    }
    this.form.controls.condition_id.markAsTouched();
  }

  onTypeTouch(event) {
    if (event.target.value === this.product?.type?.id) {
      return;
    }
    this.form.controls.type_id.markAsTouched();
  }

  onImageChange(event: any) {
    const target = event.target as HTMLInputElement;
    const imageFiles = target.files;
    this.mediaCapture.readFile(imageFiles[0]).then((base64data) => {
      if (base64data.indexOf('data:image/') >= 0) {
        this.editImage(base64data);
      } else {
        this.showToast(this.translate.instant(marker('ValidationMessage.ValidImage')));
      }
    });
  }

  async editImage(image) {
    const modal = await this.modalCtrl.create({
      component: EditImageModalComponent,
      componentProps: {
        image
      },
      cssClass: 'edit-image-modal',
      canDismiss: true,
      id: 'editImage'
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        // push the images in array to display on frontend
        this.productImages.push({
          id: -1,
          url: data.data
        });
        this.imagesChange = true;
        console.log(this.productImages.filter(image => image.id === -1));

      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  removeImage(id: number, index: number) {
    if (id !== -1) {
      this.deletedImages.push(id);
      this.imagesChange = true;
    }
    this.productImages.splice(index, 1);
  }

  updateItem(): void {
    this.showLoader();
    this.form.patchValue({
      images: this.productImages.filter(image => image.id === -1).map(x => x.url),
      delete_media: this.deletedImages,
      category_id: this.selectedCategory?.id,
      color_id: this.selectedColor?.id,
      type_id: this.selectedType?.id,
      brand_id: this.selectedBrand?.id,
      size_id: this.selectedSize?.id
    });
    this.wardrobeService.updateProduct(this.productId, this.form.value).pipe(
      finalize(() => this.hideLoader())
    ).subscribe(res => {
      this.router.navigate(['wardrobe', 'detail', this.productId], { replaceUrl: true });
    }, error => {
      this.errorService.handle(error);
    });
  }

  async confirmDeleteProduct() {
    const alert = await this.alertCtrl.create({
      cssClass: 'delete-confirm-alert',
      header: this.translate.instant(marker('Item.Delete.ConfirmTitle')),
      message: this.translate.instant(marker('Item.Delete.ConfirmText')),
      buttons: [
        {
          text: this.translate.instant(marker('Buttons.Cancel')),
          role: 'cancel',
          cssClass: 'cancel-btn',
        },
        {
          text: this.translate.instant(marker('Item.DeleteText')),
          role: 'destructive',
          cssClass: 'delete-btn',
          handler: () => {
            this.deleteProduct();
          },
        },
      ],
    });
    await alert.present();
  }

  deleteProduct() {
    this.showLoader();
    this.wardrobeService.deleteProduct(this.productId).pipe(
      finalize(() => this.hideLoader())
    ).subscribe(() => {
      this.errorService.showToast(this.translate.instant(marker('Item.Delete.Success')));
      this.router.navigate(['tabs']);
    }, error => {
      if (error.status === 403) {
        return this.errorService.showToast(error?.error?.message);
      }
      this.errorService.handle(error);
    });
  }

}
